<template>
  <div class="row" :class="errorClass" v-if="displayField">
    <div class="col-md-4 col-lg-4 col-xl-3">
      <label class="h6 text-md-right">
        <span v-html="label"></span><br>
        <small class="text-black-50">{{labelSecondary}}</small>
      </label>
    </div>
    <div class="col-md-8 col-lg-8 col-xl-9">
      <select v-model="rejectedDowngradeOption" @change="onSelectOption($event)">
        <option class="list-group-item" v-for="info in behaviours" :value="info">
          {{ info }}
        </option>
      </select>
    </div> 
  </div>
</template>

<script>
require('vue-select-image/dist/vue-select-image.css')
export default {
  props: [
    'label',
    'labelSecondary',
    'isRequired',
    'displayField',
    'errorClass',
    'categoryNomination',
  ],
  data () {
    return {
      behaviours:null,
      behavioursChild:null,
      parentcategory:null,
      rejectedDowngradeOption: ''
    }
  },
  created () {
    console.log(' created ')
    var self = this
    self.displayField = window.location.href.includes('downgrade-manager')
    self.behaviours= []
    if (self.categoryNomination === 'On the Spot') {
      self.behaviours[0] = 'The motivation qualifies as a High 5 instead of an On the Spot'
      self.behaviours[1] = 'The nomination relates to business as usual'
      self.rejectedDowngradeOption = 'The motivation qualifies as a High 5 instead of an On the Spot'
      console.log('Field updated with content: inside component addedSelectContent ', self.label, self.rejectedDowngradeOption, self.displayField)
      self.$emit('addedCheckBoxesContent', {label: self.label, content: self.rejectedDowngradeOption, validated: true, displayField: self.displayField})
    } else if (self.categoryNomination === 'Teams') {
      self.behaviours[0] = 'The motivation qualifies as a High 5 instead of the Team Nomination'
      self.behaviours[1] = 'The nomination relates to business as usual'
      self.rejectedDowngradeOption = 'The motivation qualifies as a High 5 instead of the Team Nomination'
      console.log('Field updated with content: inside component addedSelectContent ', self.label, self.rejectedDowngradeOption, self.displayField)
      self.$emit('addedCheckBoxesContent', {label: self.label, content: self.rejectedDowngradeOption, validated: true, displayField: self.displayField})
    }
  },
  methods: {
    onSelectOption(dataImages) {
      console.log('Field updated with content: inside component addedSelectContent ', this.label, this.label, this.rejectedDowngradeOption)
      this.$emit('addedCheckBoxesContent', {label: this.label, content: this.rejectedDowngradeOption, validated: true, displayField: this.displayField})    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/FieldDowngradeRejection.vue